// oem 名称
const global = {
  // ==========> 尚米云 <==========
  //oem 名称
  oemName: '尚米云',
  //oem 开门码地址
  oemMmUrl: [{
    name: 'https://www.sanmipos.com/smDuty（新）',
    url: 'https://www.sanmipos.com/smDuty'
  },{
    name: 'https://www.sanmipos.com/smsoft/smwgo/smBoxShop（旧）',
    url: 'https://www.sanmipos.com/smsoft/smwgo/smBoxShop'
  }, ],
  // ==========> 云享都 <==========
  // oemName: '云享都',
  // // //oem 开门码地址
  // oemMmUrl: [{
  //   name: 'http://ylc.suu5.com/duty',
  //   url: 'http://ylc.suu5.com/duty'
  // }],

}



export default global



// WEBPACK FOOTER //
// ./src/assets/js/global.js